<template>
  <v-layout wrap>
    <v-flex class="none-growth">
      <v-layout align-center>
        <a
          class="counter-btn mr-3"
          :class="{ disabled: disabled }"
          @click="subtract()"
        >
          <v-icon
            :color="'#fff'"
            small
          >remove</v-icon>
        </a>
        <span class="f-2 fw-600 text-dark"> {{ count != null ? count : '--' }}</span>
        <a
          class="counter-btn ml-3"
          :class="{ disabled: disabled }"
          @click="increase()"
        >
          <v-icon
            :color="'#fff'"
            small
          >add</v-icon>
        </a>
      </v-layout>
    </v-flex>
    <v-flex
      v-if="errorMessages.length > 0"
      xs12
      mt-3
    >
      <div class="v-messages theme--light error--text">
        <div class="v-messages__wrapper">
          <div
            v-for="(error, index) in errorMessages"
            :key="index"
            class="v-messages__message"
          >
            {{ error }}
          </div>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
    name: 'CounterButtons',
    inject: ['$validator'],
    props: {
        value: {},
        disabled: {
            default: false,
            type: Boolean
        },
        'error-messages': {
            default: () => {
                return [];
            }
        }
    },
    data () {
        return {
            count: 0
        };
    },
    watch: {
        count (val) {
            this.$emit('input', val);
        }
    },
    created () {
        this.count = this.value;
    },
    methods: {
        increase () {
            if (this.disabled) {
                return;
            }
            if (this.$attrs['data-vv-name']) {
                this.$validator.flag(this.$attrs['data-vv-name'], {
                    changed: true
                });
            }
            if (this.count != null) {
                this.count++;
            } else {
                this.count = 0;
            }
        },
        subtract () {
            if (this.disabled) {
                return;
            }
            if (this.count != null && this.count > 0) {
                this.count--;
            } else {
                this.count = 0;
            }
        },
        clear () {
            this.count = 0;
        }
    }
};
</script>

<style scoped></style>
